import {
  ConfigProvider,
  Modal,
  ModalProps,
  Table,
  TableColumnsType,
} from "antd";
import classes from "./ModalChronology.module.css";
import { IModalChronologyProps } from "../../../../interfaces/props/AdminAgentInfo/IModalChronologyProps";
import { IBankChronologyTableData } from "../../../../interfaces/IBankChronologyTableData";

export const ModalChronology = ({
  width = 700,
  footer = false,
  bankName,
  ...restProps
}: IModalChronologyProps) => {
  const columnsApplication: TableColumnsType<IBankChronologyTableData> = [
    {
      title: "Тип",
      dataIndex: "type",
    },
    {
      title: "Дата начала",
      dataIndex: "startDate",
    },
    {
      title: "Дата окончания",
      dataIndex: "endDate",
    },
    {
      title: "АВ от тарифа",
      dataIndex: "agentAward",
    },
    {
      title: "Базовое превышение",
      dataIndex: "baseOverstatement",
    },
  ];

  const dataApplication: IBankChronologyTableData[] = [
    {
      type: "Предыдущее значение",
      startDate: "01.01.2024",
      endDate: "30.10.2024",
      agentAward: 30,
      baseOverstatement: 50,
    },
    {
      type: "Текущее значение",
      startDate: "01.01.2024",
      endDate: "30.10.2024",
      agentAward: 30,
      baseOverstatement: 50,
    },
  ];
  return (
    <ConfigProvider
      theme={{
        components: {
          Table: {
            borderRadius: 20,
            rowHoverBg: "#eaeaea",
            headerBorderRadius: 12,
            headerBg: "transparent",
            rowExpandedBg: "transparent",
          },
        },
      }}
    >
      <Modal width={width} footer={footer} {...restProps}>
        <div className={classes.modalTitle}>Хронология</div>

        <div className={classes.modalBankName}>{bankName}</div>

        <div className={classes.tableWrapper}>
          <Table
            dataSource={dataApplication}
            rowClassName={classes.tableRow}
            className={classes.table}
            columns={columnsApplication}
            pagination={false}
          />
        </div>
      </Modal>
    </ConfigProvider>
  );
};
